import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import Raven from 'raven-js';
import { useInteractiveModeSession } from 'copilot-toolkit/hooks/useInteractiveModeSession';
// @ts-expect-error not yet migrated
import { fetchContentSchema } from 'page-editor-ui/api/requestClients';
// @ts-expect-error not yet migrated
import { fetchContentSchemaSucceeded } from 'ContentEditorUI/redux/actions/appActions';
import { gate } from 'hub-http/gates';
import { createHasGateSelector } from 'ContentEditorUI/redux/selectors/authSelectors';
const SESSION_ID = 'page-editor';
const APP_NAME = 'page-editor-ui';
const getHasBreezeEngineUIGate = createHasGateSelector(gate('BreezeEngine:EngineUI'));
const getHasLandingPageSkillGate = createHasGateSelector(gate('Pages::BreezeAssistant::LandingPageSkill'));
const getIsUngatedForInteractiveModeRefresh = createSelector(getHasBreezeEngineUIGate, getHasLandingPageSkillGate, (hasBreezeEngineUI, hasLandingPageSkill) => {
  return !hasBreezeEngineUI && hasLandingPageSkill;
});
export const useBreezeInteractiveMode = () => {
  const dispatch = useDispatch();
  const isUngated = useSelector(getIsUngatedForInteractiveModeRefresh);
  const handleRefreshContent = useCallback(async () => {
    try {
      const result = await fetchContentSchema();
      dispatch(fetchContentSchemaSucceeded(result));
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const bus = window.hubspot.ContentEditorUI.eventBus;
      // Trigger the iframe refresh directly rather than via `preview:refresh`,
      // which shows a loading overlay that never clears because the inpage
      // DnD teardown step in handlePreviewNeedsReload may not complete.
      bus.trigger('post:refreshInpageFrame', {
        scrollX: 0,
        scrollY: 0
      });
    } catch (error) {
      Raven.captureMessage('[Breeze Interactive Mode] Error refreshing content schema', {
        extra: {
          error
        }
      });
    }
  }, [dispatch]);
  const interactiveModeActions = useMemo(() => {
    if (!isUngated) {
      return [];
    }
    return [{
      name: 'refresh_content',
      functionDescription: 'Re-fetch the latest page content schema so edits appear without a page refresh. Call this after editing any module, field, or content on the page.',
      autoApplySetting: 'always-auto-apply',
      undoSetting: 'undo-and-reapply-disabled',
      function: handleRefreshContent,
      functionParameters: {}
    }];
  }, [isUngated, handleRefreshContent]);
  useInteractiveModeSession({
    sessionId: SESSION_ID,
    appName: APP_NAME,
    interactiveModeActions,
    additionalLLMInstructions: isUngated ? 'You are in the Page Editor. After you edit any module, field, or content on the page, you MUST call refresh_content so the user sees the update immediately.' : ''
  });
};